import { AuthService } from './../../shared/services/auth.service';
import { Injectable } from '@angular/core';
import * as signalR from "@microsoft/signalr";
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SignalrHubService {
  
  private message = new BehaviorSubject<string | null>(null);
  message$ = this.message.asObservable();

  private hubConnection: signalR.HubConnection;

  constructor(
    private authService: AuthService) {
  }

  public async startConnection(): Promise<void> {

    this.hubConnection = new signalR.HubConnectionBuilder()
      .withUrl('/hub', { accessTokenFactory: () => this.authService.getToken })
      .withAutomaticReconnect()
      .build();

    await this.hubConnection.start();

    console.log('Connection started');

    this.hubConnection.on('message', (data) => {
      this.message.next(data);
    });

    this.send();

  }

  public send(): void {
    this.hubConnection.invoke('Send', "Hello");
  }

  
  public changeMessage(message: string): void {
    this.message.next(message);
  }
}
